import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { ReserveSelectDetailFormFragmentComponent } from './ReserveSelectDetailFormFragmentComponent';
import {StorageService} from '../../../../../../../Service/StorageService';
import {AppSingletonUtil} from '../../../../../../../Util/AppSingletonUtil';
import {UserService} from '../../../../../../../Service/UserService';

/**
 * ReserveSelectDetailFormFragmentController
 * 問診画面のコントローラー
 */
export class ReserveSelectDetailFormFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: ReserveSelectDetailFormFragmentComponent;

	/**
	 * ログイン済みでトークンを設定しているかどうか
	 * @returns true: トークン・ユーザー情報あり/false: トークン無し or ユーザー情報無し
	 */
	public async isExistToken(view: any) {

		// ストレージにトークンがあるかチェック
		const svc = new StorageService(this);
		const isExist = await svc.isItemExist('t');

		// トークンが存在しなければログアウト
		if (!isExist) {
			return false;
		}
		// トークンを取得
		const token = await svc.getItem('t');
		if (!token) {
			// トークンの値が存在しない場合
			await svc.clear();
			return false;
		}
		AppSingletonUtil.setToken(token);

		// ユーザー情報を取得
		// トークンでユーザー情報が取得できるかどうか
		const userSvc = new UserService(view);
		const user = await userSvc.getUserInfo();
		if (!user) {
			// ユーザー情報取れない場合は終了
			await svc.clear();
			return false;
		}
		AppSingletonUtil.setUserInfo(user);

		return true;
	}

}
